import { getConnector, getDomainName, getLocalPart, getTopLevelDomain, convertToMask } from './urlMaskFunctions'
import log from 'loglevel'

const emptyString = ''
const dot = '.'
const WS = 'www'
const allWhitespaceRegExp = /\s/g

const urlMask = (rawValue, config) => {
  rawValue = rawValue.replace(allWhitespaceRegExp, emptyString)

  const { placeholderChar, currentCaretPosition } = config
  const indexOfFirstWS = rawValue.indexOf(WS)
  const indexOfLastDot = rawValue.lastIndexOf(dot)
  const indexOfTopLevelDomainDot = (indexOfLastDot < indexOfFirstWS) ? -1 : indexOfLastDot

  const localPartToDomainConnector = getConnector(rawValue, indexOfFirstWS + 1, WS)
  const domainNameToTopLevelDomainConnector = getConnector(rawValue, indexOfTopLevelDomainDot - 1, dot)

  let localPart = getLocalPart(rawValue, indexOfFirstWS)
  let domainName = getDomainName(rawValue, indexOfFirstWS, indexOfTopLevelDomainDot, placeholderChar)
  let topLevelDomain = getTopLevelDomain(rawValue, indexOfTopLevelDomainDot, placeholderChar, currentCaretPosition)

  localPart = convertToMask(localPart)
  domainName = convertToMask(domainName)

  topLevelDomain = convertToMask(topLevelDomain, true)

  const mask = localPartToDomainConnector
    .concat(localPart)
    .concat(domainName)
    .concat(domainNameToTopLevelDomainConnector)
    .concat(topLevelDomain)

  log.debug(mask)

  return mask
}

export default urlMask
